<script lang="ts">
  import { state, setCurrentView } from '../../stores/launchpad.svelte'

  const views = [
    'got-contacts',
    'got-no-contacts',
    'auto-response',
    // 'tour',
  ]

  let isFirstRun = $derived(state.isFirstRun)

  const currentView = $derived(state.currentView)
  let currentViewIndex = $derived(views.indexOf(currentView))
  let shouldShowBack = $derived(views.indexOf(currentView) > 0)
  let shouldShowFinished = $derived(views.indexOf(currentView) >= views.length - 1)
  let shouldShowNext = $derived(views.indexOf(currentView) < views.length - 1)

  function navBack() {
    let prevView = views[currentViewIndex - 1]

    if (prevView) {
      setCurrentView(prevView)
    }
  }

  function navFinished() {
    document.querySelector('.LaunchpadModal .modal-close').click()
    setCurrentView('index')
  }

  function navNext() {
    let nextView = views[currentViewIndex + 1]

    if (nextView) {
      setCurrentView(nextView)
    }
  }
</script>

{#if isFirstRun}
  <div class="LaunchpadNavBottom">
    {#if shouldShowBack}
      <button onclick={navBack} class="btn btn-link">
        <i class="icon icon--chevron-left"></i>
        Back
      </button>
      <span class="spacer"></span>
    {/if}

    {#if shouldShowNext}
      <button onclick={navNext} class="btn btn-link">
        Next
        <i class="icon icon--chevron-right"></i>
      </button>
    {/if}

    {#if shouldShowFinished}
      <button onclick={navFinished} class="btn btn-link">
        Finished
      </button>
    {/if}
  </div>
{/if}
